/* RESPONSIBLE TEAM: team-automation-foundations */
import FinAIAgentAnalyzePerformanceRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/performance';

export default class FinAiAgentEcommercePerformanceRoute extends FinAIAgentAnalyzePerformanceRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.performance',
  };
}
